<!-- <div class="product-main-container" *ngIf="!isMobile()">
  <div class="title-div rect-view">
    <mat-grid-list [cols]="7" rowHeight="300px">
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mt-2">
        <ng-lottie [options]="lottieOptions" [width]="'300px'"></ng-lottie>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="4" [rowspan]="1" class="text">
        <div>
          <div class="title">All you need to Elevate <br> School's Performance
          </div>
          <div class="sub-title">
            Personalized Solutions Tailored to Your <br> School's Digital Demands <br>
            <small style="color: grey; font-size: 12px; font-weight: 400;">Real Time Insights of Complete Ecosystem in
              Single Screen</small>
          </div>
        </div>
      </mat-grid-tile>

    </mat-grid-list>
  </div>
  <div class="product-div rect-view display">
    <div style="width: 950px;">
      <div class="product-list">
        <div class="d-flex display" (click)="onTabclick(1)">
          <div class="display focuss"><img src="../../assets/images/Group 7540.svg" style="width: 20%;"><span
              class="img-text">Finance</span></div>
          <div [ngClass]="financeTab ? 'focus-line':''"></div>
        </div>
        <div class="d-flex display" (click)="onTabclick(2)">
          <div class="display focuss"><img src="../../assets/images/Group 7131.svg" style="width: 15%;"><span
              class="img-text">Communication</span></div>
          <div [ngClass]="communicationTab ? 'focus-line':''"></div>
        </div>
        <div class=" d-flex display" (click)="onTabclick(3)">
          <div class="display focuss"><img src="../../assets/images/Group 7130.svg" style="width: 20%;"><span
              class="img-text">People</span></div>
          <div [ngClass]="peopletab ? 'focus-line':''"></div>
        </div>
        <div class="d-flex display" (click)="onTabclick(4)">
          <div class="display focuss"><img src="../../assets/images/Group 7160.svg" style="width: 15%;"><span
              class="img-text">Classroom</span></div>
          <div [ngClass]="classroomTab ? 'focus-line':''"></div>
        </div>
      </div>
      <div style="margin: 50px 0px 20px 0px" *ngIf="financeTab">
        <div style="display: flex;"><img src="../../assets/images/Group 7540.svg">
          <div style="margin-left: 15px;"><span class="img-text" style="margin: 0px;font-size: 23px">Finance</span><br>
            <span class="sub-title" style="font-size: 19px; font-weight: 500;">Digitise and automate all finance
              operations and improve collection efficiency.</span>
          </div>
        </div>
        <div>
          <mat-grid-list [cols]="6" rowHeight="600px">
            <mat-grid-tile [colspan]="2" [rowspan]="1" class="text">
              <div>
                <div class="product-sm-card rect-view focuss " (click)="onCardClick(1)"
                  [ngStyle]="{'background-color':frstCard ? '#57D383' : '' }"><span class="card-text">1.<br>Fee
                    <br>Collection</span></div>
                <div class="product-sm-card rect-view focuss " (click)="onCardClick(2)"
                  [ngStyle]="{'background-color':secondCard ? '#57D383' : '' }"><span class="card-text">2.<br>Income
                    &<br>Expense</span></div>
                <div class="product-sm-card rect-view focuss " (click)="onCardClick(3)"
                  [ngStyle]="{'background-color':thirdCard ? '#57D383' : '' }"><span class="card-text">3.<br>Payroll for
                    <br>your staff</span></div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="4" [rowspan]="1">
              <div class="product-bg-card rect-view display" style=" background-color: #DEF5E6;">
                <div class="finance-img" *ngIf="frstCard">
                  <span><img src="../../assets/images/Group 7683.svg" style="position: absolute;"></span>
                  <span><img src="../../assets/images/Group 7624.svg" class="img-2"></span>
                  <span><img src="../../assets/images/Group 7622.svg"
                      style="position: absolute;margin-top: 80px;"></span>
                  <span><img src="../../assets/images/Group 7625.svg" class="img-3"></span>
                  <span><img src="../../assets/images/Group 7623.svg" class="img-4"></span>
                  <span><img src="../../assets/images/Group 7626.svg" class="img-5"></span>
                </div>
                <div class="finance-img display" *ngIf="secondCard" style="flex-wrap:wrap">

                  <div class="finance-card2-img1"><img src="../../assets/images/Group 7605.svg" style="width: 85%;">
                  </div>
                  <div class="finance-card2-img2"><img src="../../assets/images/Group 7604.svg" style="width: 83%;">
                  </div>
                  <div class="finance-card2-img3"><img src="../../assets/images/Group 7603.svg" style="width: 85%;">
                  </div>
                  <div class="finance-card2-img4"><img src="../../assets/images/Group 7602.svg" style="width: 100%;">
                  </div>

                </div>
                <div class="finance-img display" *ngIf="thirdCard" style="flex-wrap:wrap">

                  <div class="finance-card3-img1"><img src="../../assets/images/Group 7630.svg" style="width: 85%;">
                  </div>
                  <div class="finance-card3-img2"><img src="../../assets/images/Group 3429.svg" style="width:85%"></div>
                  <div class="finance-card3-img3"><img src="../../assets/images/Group 7629.svg" style="width: 90%;">
                  </div>

                </div>
              </div>
            </mat-grid-tile>

          </mat-grid-list>
        </div>

      </div>
      <div style="margin: 50px 0px 20px 0px" *ngIf="communicationTab">
        <div style="display: flex;"><img src="../../assets/images/Group 7131.svg">
          <div style="margin-left: 15px;"><span class="img-text"
              style="margin: 0px;font-size: 23px">Communication</span><br>
            <span class="sub-title" style="font-size: 19px; font-weight: 500;">Implement communication channel across
              eco-system</span>
          </div>
        </div>
        <div>
          <mat-grid-list [cols]="6" rowHeight="600px">
            <mat-grid-tile [colspan]="2" [rowspan]="1" class="text">
              <div>
                <div class="product-sm-card rect-view focuss " role="button" (click)="onCardClick(1)"
                  [ngStyle]="{'background-color':frstCard ? '#3A87FE' : '' }"><span class="card-text">1.<br>School
                    <br>Calander</span></div>
                <div class="product-sm-card rect-view focuss " role="button" (click)="onCardClick(2)"
                  [ngStyle]="{'background-color':secondCard ? '#3A87FE' : '' }"><span
                    class="card-text">2.<br>Notifications</span></div>
                <div class="product-sm-card rect-view focuss " role="button" (click)="onCardClick(3)"
                  [ngStyle]="{'background-color':thirdCard ? '#3A87FE' : '' }"><span
                    class="card-text">3.<br>Activity<br>Feed</span></div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="4" [rowspan]="1">
              <div class="product-bg-card rect-view display" style=" background-color: #CAD5E6;">
                <div class="finance-img " *ngIf="frstCard" style="margin-top: 85px;">
                  <span><img src="../../assets/images/Group 7722.svg" style="width: 100%;"></span>

                </div>
                <div class="finance-img " *ngIf="secondCard" style="margin-top: 60px;">
                  <span><img src="../../assets/images/Group 7724.svg" style="width: 100%;"></span>

                </div>
                <div class="finance-img " *ngIf="thirdCard" style="margin-top: 55px; text-align: center;">
                  <span><img src="../../assets/images/Group 7726.svg" style="width: 90%;"></span>

                </div>
              </div>
            </mat-grid-tile>

          </mat-grid-list>
        </div>

      </div>
      <div style="margin: 50px 0px 20px 0px" *ngIf="peopletab">
        <div style="display: flex;"><img src="../../assets/images/Group 7130.svg">
          <div style="margin-left: 15px;"><span class="img-text" style="margin: 0px;font-size: 23px">People</span><br>
            <span class="sub-title" style="font-size: 19px; font-weight: 500;">All you need to measure and improve
              people performance</span>
          </div>
        </div>
        <div>
          <mat-grid-list [cols]="6" rowHeight="600px">
            <mat-grid-tile [colspan]="2" [rowspan]="1" class="text">
              <div>
                <div class="product-sm-card rect-view focuss " role="button" (click)="onCardClick(1)"
                  [ngStyle]="{'background-color':frstCard ? '#FFC402' : '' }"><span
                    class="card-text">1.<br>Attendance</span></div>
                <div class="product-sm-card rect-view focuss " role="button" (click)="onCardClick(2)"
                  [ngStyle]="{'background-color':secondCard ? '#FFC402' : '' }"><span class="card-text">2.<br>People
                    <br> Performance</span></div>
                <div class="product-sm-card rect-view focuss " role="button" (click)="onCardClick(3)"
                  [ngStyle]="{'background-color':thirdCard ? '#FFC402' : '' }"><span class="card-text">3.<br>Roles
                    and<br>Permissions</span></div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="4" [rowspan]="1">
              <div class="product-bg-card rect-view display" style=" background-color: #FAF2D9;">
                <div class="finance-img " *ngIf="frstCard" style="margin-top: 85px;">
                  <span><img src="../../assets/images/Group 7638.svg" style="width: 100%;"></span>

                </div>
                <div class="finance-img " *ngIf="secondCard" style="margin-top: 60px;">
                  <span><img src="../../assets/images/Group 7638.svg" style="width: 100%;"></span>

                </div>
                <div class="finance-img " *ngIf="thirdCard" style="margin-top: 55px; text-align: center;">
                  <span><img src="../../assets/images/Group 7677.svg" style="width: 90%;"></span>

                </div>
              </div>
            </mat-grid-tile>

          </mat-grid-list>
        </div>
      </div>
      <div style="margin: 50px 0px 20px 0px" *ngIf="classroomTab">
        <div style="display: flex;"><img src="../../assets/images/Group 7160.svg">
          <div style="margin-left: 15px;"><span class="img-text"
              style="margin: 0px;font-size: 23px">Classroom</span><br>
            <span class="sub-title" style="font-size: 19px; font-weight: 500;">All you need to measure and improve
              people performance</span>
          </div>
        </div>
        <div>
          <mat-grid-list [cols]="6" rowHeight="600px">
            <mat-grid-tile [colspan]="2" [rowspan]="1" class="text">
              <div>
                <div class="product-sm-card rect-view focuss " role="button" (click)="onCardClick(1)"
                  [ngStyle]="{'background-color':frstCard ? '#FF3200' : '' }"><span class="card-text">1.<br>Dynamic
                    <br>Timetable</span></div>
                <div class="product-sm-card rect-view focuss " role="button" (click)="onCardClick(2)"
                  [ngStyle]="{'background-color':secondCard ? '#FF3200' : '' }"><span class="card-text">2.<br>Class <br>
                    Performance</span></div>
                <div class="product-sm-card rect-view focuss " role="button" (click)="onCardClick(3)"
                  [ngStyle]="{'background-color':thirdCard ? '#FF3200' : '' }"><span
                    class="card-text">3.<br>Classroom<br>Vault</span></div>
              </div>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="4" [rowspan]="1">
              <div class="product-bg-card rect-view display" style=" background-color: #E7D7D2;">
                <div class="finance-img " *ngIf="frstCard" style="margin-top: 85px;">
                  <span><img src="../../assets/images/Group 7682.svg" style="width: 100%;"></span>

                </div>
                <div class="finance-img " *ngIf="secondCard" style="margin-top: 60px;">
                  <span><img src="../../assets/images/Group 7681.svg" style="width: 100%;"></span>

                </div>
                <div class="finance-img " *ngIf="thirdCard" style="margin-top: 55px; text-align: center;">
                  <span><img src="../../assets/images/Group 1122.png" style="width: 103%;"></span>

                </div>
              </div>
            </mat-grid-tile>

          </mat-grid-list>
        </div>
      </div>
    </div>
  </div>
</div> -->
<!-- <div *ngIf="isMobile()" class="product-main-container">
  <div class="title-div d-flex rect-view" style="margin-bottom: 20px;">
    <div class="img-div">
      <ng-lottie [options]="lottieOptions" [width]="'300px'"></ng-lottie>
    </div>
    <div style="width:96%">
      <div>
        <div class="title">All you need to Elevate School's Performance
        </div>
        <div class="sub-title">
          Personalized Solutions Tailored to Your <br> School's Digital Demands <br>
          <small style="color: grey; font-size: 12px; font-weight: 400;">Real Time Insights of Complete Ecosystem in
            Single Screen</small>
        </div>
      </div>
    </div>
    <div>
      <button mat-raised-button class="btn-get" (click)="openDialog()">
        Book a demo &nbsp;&nbsp;
        <mat-icon>arrow_right_alt</mat-icon>
      </button>
    </div>
  </div>
  <div *ngFor="let card of productCards">
    <div class="finance rect-view" style="border-radius: 15px; margin: 0px;">

      <div style="display: flex; margin: 20px;"><img [src]="card.logo">
        <div style="margin-left: 15px;"><span class="img-text text1">{{card.Label}}</span><br>
          <span class="sub-title" style="font-size: 14px;
          line-height: 22px;
          font-weight: 400; ">{{card.description}}</span>
        </div>
      </div>
    </div>
    <div *ngFor="let images of card.imgsrc; let cardIndex=index" class="product-bg-card rect-view display"
      [style.backgroundColor]="card.color">
      <div style="margin: 25px;"><span class="card-text">{{cardIndex+1}}.</span> <span
          class="label-txt">{{images.name}}</span> </div>
      <div class="finance-img ">
        <span><img [src]="images.url" style="width: 100%;"></span>

      </div>

    </div>

  </div>
</div> -->

<div class="container">
  <div class="input-wrapper">
    <div class="left-section">
      <img
        src="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/orbit-logo.png"
        class="left-image"
      />
      <h1 class="heading">
        All you need to
        <span class="highlight"> Elevate School's </span>
        Performance<span class="dot"></span>
      </h1>
      <p>
        Streamline your entire school operations with a powerful ERP, managing
        academics, finance, communication, and administration—all from a single,
        integrated dashboard for effortless efficiency.
      </p>
      <div class="buttons">
        <button class="button blue" (click)="goToPage()">
          Get School Dashboard
        </button>
        <!-- <button class="button green" (click)="goToWhatsApp()">
          <p>Join Our community</p>
          <p style="display: flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 39 39"
            >
              <path
                fill="#00E676"
                d="M10.7 32.8l.6.3c2.5 1.5 5.3 2.2 8.1 2.2 8.8 0 16-7.2 16-16 0-4.2-1.7-8.3-4.7-11.3s-7-4.7-11.3-4.7c-8.8 0-16 7.2-15.9 16.1 0 3 .9 5.9 2.4 8.4l.4.6-1.6 5.9 6-1.5z"
              ></path>
              <path
                fill="#FFF"
                d="M32.4 6.4C29 2.9 24.3 1 19.5 1 9.3 1 1.1 9.3 1.2 19.4c0 3.2.9 6.3 2.4 9.1L1 38l9.7-2.5c2.7 1.5 5.7 2.2 8.7 2.2 10.1 0 18.3-8.3 18.3-18.4 0-4.9-1.9-9.5-5.3-12.9zM19.5 34.6c-2.7 0-5.4-.7-7.7-2.1l-.6-.3-5.8 1.5L6.9 28l-.4-.6c-4.4-7.1-2.3-16.5 4.9-20.9s16.5-2.3 20.9 4.9 2.3 16.5-4.9 20.9c-2.3 1.5-5.1 2.3-7.9 2.3zm8.8-11.1l-1.1-.5s-1.6-.7-2.6-1.2c-.1 0-.2-.1-.3-.1-.3 0-.5.1-.7.2 0 0-.1.1-1.5 1.7-.1.2-.3.3-.5.3h-.1c-.1 0-.3-.1-.4-.2l-.5-.2c-1.1-.5-2.1-1.1-2.9-1.9-.2-.2-.5-.4-.7-.6-.7-.7-1.4-1.5-1.9-2.4l-.1-.2c-.1-.1-.1-.2-.2-.4 0-.2 0-.4.1-.5 0 0 .4-.5.7-.8.2-.2.3-.5.5-.7.2-.3.3-.7.2-1-.1-.5-1.3-3.2-1.6-3.8-.2-.3-.4-.4-.7-.5h-1.1c-.2 0-.4.1-.6.1l-.1.1c-.2.1-.4.3-.6.4-.2.2-.3.4-.5.6-.7.9-1.1 2-1.1 3.1 0 .8.2 1.6.5 2.3l.1.3c.9 1.9 2.1 3.6 3.7 5.1l.4.4c.3.3.6.5.8.8 2.1 1.8 4.5 3.1 7.2 3.8.3.1.7.1 1 .2h1c.5 0 1.1-.2 1.5-.4.3-.2.5-.2.7-.4l.2-.2c.2-.2.4-.3.6-.5s.4-.4.5-.6c.2-.4.3-.9.4-1.4v-.7s-.1-.1-.3-.2z"
              ></path>
            </svg>
          </p>
        </button> -->
      </div>
      <div *ngIf="logoUrl?.length">
        <div class="carousel-container">
          <div class="carousel-images">
            <!-- <ng-image-slider
              [imageSize]="getImgSize()"
              [autoSlide]="autoSlide"
              [infinite]="infiniteSlide"
              [showArrow]="false"
              [animationSpeed]="1"
              [images]="logoUrl"
              #gallery
            ></ng-image-slider> -->
            <div class="marquee-wrapper">
              <om-marquee [animationDuration]="'40s'">
                <div
                  class="marquee-card"
                  *ngFor="let logo of logoUrl"
                  #OmMarqueeContent
                >
                  <img [src]="logo.url" class="school-logos" />
                </div>
              </om-marquee>
              <div class="marquee-gradient left"></div>
              <div class="marquee-gradient right"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-section">
      <img
        src="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/orbit-logo.png"
        class="mobile-logo"
      />
      <img
        src="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/orbit-main-image.png"
        alt="image"
        class="main-image"
      />
    </div>
  </div>
</div>
<div class="main-container" *ngIf="!isMobile()">
  <div class="sidebar">
    <div class="navigation-sections">
      <div *ngFor="let card of cards" class="section">
        <div
          class="section-header"
          [class.active]="isSectionActive(card.name)"
          (click)="toggleSection(card.name)"
        >
          <div class="section-title">
            <span>{{ card.name }}</span>
          </div>
          <i
            class="fa"
            [ngClass]="
              isSectionActive(card.name)
                ? 'fa-chevron-down'
                : 'fa-chevron-right'
            "
          ></i>
        </div>
        <div
          [@expandCollapse]="getSectionState(card.name)"
          class="section-details"
        >
          <div
            *ngFor="let detail of card.details"
            class="detail-item"
            [class.active]="isDetailActive(detail.name)"
            (click)="changeDetail(detail)"
          >
            {{ detail.name }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="content-area">
    <div class="content-container">
      <div [@fadeInOut]="selectedDetail?.name" class="image-container">
        <img
          [src]="selectedDetail?.image"
          [alt]="selectedDetail?.name"
          class="content-image"
        />
      </div>
    </div>
  </div>
</div>

<div class="mobile-feature-cards" *ngIf="isMobile()">
  <ng-container *ngFor="let category of cards; let categoryIndex = index">
    <button class="category-button">
      <span>{{ category.name }}</span>
    </button>

    <button
      *ngFor="let detail of category.details; let detailIndex = index"
      class="detail-button"
    >
      <div class="detail-content">
        <div class="icon-container">
          <img [src]="detail.image" [alt]="detail.name" class="image-icon" />
        </div>
        <div class="detail-name">{{ detail.name }}</div>
      </div>
    </button>

    <div class="category-spacer" *ngIf="categoryIndex < cards.length - 1"></div>
  </ng-container>
</div>

<div class="intro-wrapper">
  <h2>Ready To Make your School Smart?</h2>
  <p>
    Whether you're managing daily operations or optimizing school workflows,
    Orbit brings your entire school management—academics, finance, and
    communication— into one seamless, AI-powered dashboard!
  </p>
  <button (click)="goToPage()">Transform Your School with Orbit →</button>
</div>
